// CAM(발령·인사이동) 도메인 라우트. route name = OBJECT_ID, 폴더는 pages/cam.
// 메뉴 위치는 인사기본과 환경설정으로 나뉘지만 도메인 코드가 권위라 라우트는 이 파일로 통합한다.
const routes = [
  {
    // 발령등록 - 탭(발령/승호발령) + 조회(등록일자·진행상태·품의명) + 발령 등록 내역 그리드(등록·삭제) (인사기본 > 발령관리)
    path: 'cam/order-reg',
    name: 'CAM0010',
    component: () => import('@/pages/cam/CAM0010.vue'),
    meta: {
      requiresAuth: true,
      title: '발령등록',
      menuId: 'CAM0010',
      objInfo: 'CAM0010 · 인사기본/발령관리 (미래모델·퍼블리싱)',
    },
  },
  {
    // 발령내역 - 탭 7개(전체/휴직/파견/겸직/이동/승진/퇴직) + 조회 + 공통 그리드(발령 전/후 그룹 헤더) (인사기본 > 발령관리)
    path: 'cam/order-list',
    name: 'CAM0020',
    component: () => import('@/pages/cam/CAM0020.vue'),
    meta: {
      requiresAuth: true,
      title: '발령내역',
      menuId: 'CAM0020',
      objInfo: 'CAM0020 · 인사기본/발령관리 (미래모델·퍼블리싱)',
    },
  },
  {
    // 입사발령 - 탭(입사발령등록 / 채용합격자[1차 제외]) + 조회(등록일자*·채용공고명·진행상태) + 발령 등록 내역 그리드(등록·삭제) (인사기본 > 발령관리)
    path: 'cam/order-join',
    name: 'CAM0030',
    component: () => import('@/pages/cam/CAM0030.vue'),
    meta: {
      requiresAuth: true,
      title: '입사발령',
      menuId: 'CAM0030',
      objInfo: 'CAM0030 · 인사기본/발령관리 (미래모델·퍼블리싱)',
    },
  },
  {
    // 입사내역 - 조회(입사일자*·입사구분·경력구분·사원·품의명) + 입사자 조회 그리드(flat 다컬럼, 다운로드만) (인사기본 > 발령관리). 조회전용.
    path: 'cam/order-join-list',
    name: 'CAM0040',
    component: () => import('@/pages/cam/CAM0040.vue'),
    meta: {
      requiresAuth: true,
      title: '입사내역',
      menuId: 'CAM0040',
      objInfo: 'CAM0040 · 인사기본/발령관리 (미래모델·퍼블리싱)',
    },
  },
  {
    // 발령기준관리 - 발령세부코드기준 + 발령변경항목기준 (환경설정 > 업무기준설정 > 발령기준)
    path: 'env/appt-criteria',
    name: 'CAM0011',
    component: () => import('@/pages/cam/CAM0011.vue'),
    meta: {
      requiresAuth: true,
      title: '발령기준관리',
      menuId: 'CAM0011',
      objInfo: 'CAM0011 · 환경설정/업무기준설정/발령기준 (미래모델·퍼블리싱)',
    },
  },
  {
    // 승진발령기준 - 승진소요연한기준 + 인사평가정보기준(1차 제외) (환경설정 > 업무기준설정 > 발령기준)
    path: 'env/promotion-criteria',
    name: 'CAM0012',
    component: () => import('@/pages/cam/CAM0012.vue'),
    meta: {
      requiresAuth: true,
      title: '승진발령기준',
      menuId: 'CAM0012',
      objInfo: 'CAM0012 · 환경설정/업무기준설정/발령기준 (미래모델·퍼블리싱)',
    },
  },
];

export default routes;
